var map = {
	"./oled.png": "5f86",
	"./premio1.png": "7fe4",
	"./premio2.png": "19fe",
	"./premio3.png": "cf67",
	"./premio4.png": "2783",
	"./premio5.jpeg": "6452",
	"./premio6.jpeg": "af4e",
	"./premio7.png": "db51",
	"./premio8.jpeg": "8d32"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f726";